<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.71,7.29C15.71,7.29,12.71,4.29,12.71,4.29C12.53,4.109999999999999,12.28,4,12,4C11.45,4,11,4.45,11,5C11,5.279999999999999,11.11,5.529999999999999,11.29,5.71C11.29,5.71,13.59,8,13.59,8C13.59,8,11.3,10.29,11.3,10.29C11.11,10.47,11,10.72,11,11C11,11.55,11.45,12,12,12C12.28,12,12.53,11.89,12.71,11.71C12.71,11.71,15.71,8.71,15.71,8.71C15.89,8.530000000000001,16,8.280000000000001,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,15.71,7.29,15.71,7.29ZM5,5C5,4.45,4.55,4,4,4C3.72,4,3.47,4.109999999999999,3.29,4.29C3.29,4.29,0.29,7.29,0.29,7.29C0.11,7.47,0,7.72,0,8C0,8.280000000000001,0.11,8.530000000000001,0.29,8.71C0.29,8.71,3.29,11.71,3.29,11.71C3.47,11.89,3.72,12,4,12C4.55,12,5,11.55,5,11C5,10.72,4.89,10.47,4.71,10.29C4.71,10.29,2.41,8,2.41,8C2.41,8,4.7,5.71,4.7,5.71C4.89,5.529999999999999,5,5.279999999999999,5,5C5,5,5,5,5,5ZM9,2C8.52,2,8.13,2.35,8.04,2.81C8.04,2.81,6.04,12.81,6.04,12.81C6.03,12.87,6,12.93,6,13C6,13.55,6.45,14,7,14C7.48,14,7.87,13.65,7.96,13.19C7.96,13.19,9.96,3.19,9.96,3.19C9.97,3.13,10,3.0700000000000003,10,3C10,2.45,9.55,2,9,2C9,2,9,2,9,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Code',
} as DefineComponent
</script>
